export default "__VITE_PUBLIC_ASSET__ecbfd130__"